module.exports = __webpack_public_path__ + "img/advantage6Red.b748d32c.png";